<script setup lang="ts">
import { DSSkeleton } from '@ds'

/*
 * A representative, static shape — not derived from real data (there isn't any yet). Mirrors
 * `AssetTreeRow.vue`'s own column layout (indent spacers, chevron/dot, name + optional
 * sub-label, balance + optional secondary value) so the loading state reads as "this panel,
 * still loading" rather than a generic placeholder.
 */
const ROWS = [
  { depth: 0, nameWidth: 'w-28', hasSub: false, hasAmount: false },
  { depth: 1, nameWidth: 'w-20', hasSub: true, hasAmount: false },
  { depth: 2, nameWidth: 'w-32', hasSub: true, hasAmount: true },
  { depth: 2, nameWidth: 'w-24', hasSub: false, hasAmount: true },
  { depth: 1, nameWidth: 'w-16', hasSub: false, hasAmount: false },
  { depth: 2, nameWidth: 'w-28', hasSub: true, hasAmount: true },
  { depth: 1, nameWidth: 'w-24', hasSub: true, hasAmount: false },
]
</script>

<template>
  <div
    class="flex flex-col gap-0.5 px-2 pb-2"
    aria-hidden="true"
  >
    <div
      v-for="(row, index) in ROWS"
      :key="index"
      class="flex items-center gap-0.5 pl-1.5 pr-1 py-1.25"
    >
      <span
        v-for="depth in row.depth"
        :key="depth"
        class="w-4 h-5.5 shrink-0"
      />
      <DSSkeleton class="size-3.5 rounded-full shrink-0 mr-1.5" />
      <div class="flex-1 min-w-0 flex flex-col gap-1">
        <DSSkeleton
          class="h-3"
          :class="row.nameWidth"
        />
        <DSSkeleton
          v-if="row.hasSub"
          class="h-2.5 w-12"
        />
      </div>
      <div class="shrink-0 flex flex-col items-end gap-1 ml-2">
        <DSSkeleton class="h-3 w-12" />
        <DSSkeleton
          v-if="row.hasAmount"
          class="h-2.5 w-8"
        />
      </div>
    </div>
  </div>
</template>
